<script setup>
import { ref, onMounted } from 'vue';
import { get_recent_uploads } from '@/services/interventions';
import { formattedDate, swalError } from '@/helper';

const isLoading = ref(true);
const uploads = ref([]);

onMounted(async () => {
  await fetchRecentUploads();
  isLoading.value = false;
});

async function fetchRecentUploads() {
  const response = await get_recent_uploads(10);
  if (!response.error) {
    uploads.value = response.result;
  } else {
    swalError(response.result, true);
  }
}
</script>

<template>
  <div class="card intervention-review-card">
    <div class="card-header d-flex align-items-center justify-content-between">
      <h5>Recent User Intervention Uploads</h5>
      <span class="badge bg-light-primary text-primary">{{ uploads.length }} New</span>
    </div>
    
    <div class="card-body">
      <loadingCard v-if="isLoading" loadingType="list"/>
      
      <div v-else-if="uploads.length === 0" class="text-center py-4">
        <vue-feather type="inbox" class="text-muted mb-2" size="24"></vue-feather>
        <p class="text-muted">No recent uploads</p>
      </div>
      
      <div v-else class="upload-list">
        <div 
          v-for="upload in uploads" 
          :key="upload.id"
          class="upload-item d-flex align-items-center justify-content-between py-3"
        >
          <div class="upload-info">
            <div class="d-flex align-items-center mb-1">
              <div class="icon-circle bg-light-success me-2">
                <vue-feather type="image" class="text-success" size="16"></vue-feather>
              </div>
              <h6 class="mb-0">{{ upload.child_name }}</h6>
            </div>
            <p class="text-muted mb-0 small">{{ upload.intervention_title }}</p>
            <small class="text-muted">{{ formattedDate(upload.created_at) }}</small>
          </div>
          
          <div class="upload-actions">
            <router-link 
              :to="{ 
                name: 'edit-intervention', 
                params: { id: upload.intervention_id }
              }"
              class="btn btn-sm btn-light-primary"
            >
              <vue-feather type="eye" size="14" class="me-1"></vue-feather>
              View
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.intervention-review-card {
  height: 100%;
}

.upload-item {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s;
}

.upload-item:hover {
  background-color: #f8f9fa;
}

.upload-item:last-child {
  border-bottom: none;
}

.upload-info h6 {
  font-size: 0.9rem;
  font-weight: 600;
}

.icon-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg-light-success {
  background-color: rgba(81, 187, 37, 0.1);
}
</style>
